import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { iif, Observable, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';

import { AuthState, AuthStore } from '@store';

@Injectable()
export class InvitationsAuthGuardService {
  constructor(private authStore: AuthStore, private router: Router) {}

  canActivateChild(): Observable<boolean> {
    return this.checkAuth();
  }

  canActivate(): Observable<boolean> {
    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean> {
    return this.authStore.state$.pipe(
      filter((state: AuthState) => {
        if (!state.authorized && !state.authorizing && !state.authenticating) {
          this.router.navigate(['/home']);
        }

        return state.authorized;
      }),
      mergeMap((state: AuthState) =>
        iif(() => state.demo, of(true), this.authStore.userHasAccessToInvitations())
      )
    );
  }
}
